import { render, staticRenderFns } from "./configureGetLinkTemplate.vue?vue&type=template&id=614798bc&scoped=true"
import script from "./configureGetLinkTemplate.vue?vue&type=script&lang=js"
export * from "./configureGetLinkTemplate.vue?vue&type=script&lang=js"
import style0 from "./configureGetLinkTemplate.vue?vue&type=style&index=0&id=614798bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614798bc",
  null
  
)

export default component.exports